import client from './client'

export function setTrackReaction(trackId, value) {
  return client.put(`/api/v1/tracks/${trackId}/reaction`, { value })
}

export function removeTrackReaction(trackId) {
  return client.delete(`/api/v1/tracks/${trackId}/reaction`)
}

export function setCommentReaction(trackId, commentId, value) {
  return client.put(`/api/v1/tracks/${trackId}/comments/${commentId}/reaction`, { value })
}

export function removeCommentReaction(trackId, commentId) {
  return client.delete(`/api/v1/tracks/${trackId}/comments/${commentId}/reaction`)
}
